(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TriggeredEmailSurvey',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.trip-type-field').on('change', function toggleCruiseLand(e) {
			var selection = $(".trip-type-field option:selected").text();

			if (selection === 'Cruise') {
				$('.cruise-trip').removeClass('hidden');
				$('.tour-trip').addClass('hidden');
				$('.tour-trip-field').val("");

			} else if (selection === 'Land') {
				$('.cruise-trip').addClass('hidden');
				$('.tour-trip').removeClass('hidden');
				$('.cruise-trip-field').val("");

			} else {
				$('.tour-trip').addClass('hidden');
				$('.cruise-trip').addClass('hidden');
				$('.tour-trip-field').val("");
				$('.cruise-trip-field').val("");
			}
		});

		$('.company-recommend-field').on('change', function toggleCompanyRecommendComment(e) {
			$('.company-recommend-comment').removeClass('hidden');
		
		});

		// this will prevent the drowdown header to change.
		$form.on('shown.bs.select', function optgroupSelectAll(e) {
		    e.stopPropagation();
		});
		
		$('select.survey-where-next').change(function changing(e) {
			// loop thru all options of hidden multi select input
			$('.survey-where-next option').each(function selecting(e, val) {
				var $self = $(this);
				
				// show span under select
				if ($self.is(":selected")) {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').removeClass('hidden');
				// hide span
				} else {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').addClass('hidden');
				}
			});
		}).trigger('change');

	};
}(jQuery, window.Adzuki || {}));

















		